module.exports = "<div class=\"accAuthContainer\">\n  <div class=\"imgContainer\"></div>\n  <div class=\"content\">\n    The Account Authentication configuration page has been moved to the Users Settings page of the Console.\n    <br>\n    <a class=\"asui-btn btn btn-primary authentication-link\" ng-href=\"{{$ctrl.accountAuthenticationUrl}}\" target=\"_blank\">Go to Console</a>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/settings/components/accountAuthentication/accountAuthentication.component.html
// module id = 647
// module chunks = 0